import  { useEffect, useState } from 'react';
import { Button, InputGroup, Modal, ToggleButton } from 'react-bootstrap';
import { FaEnvelope, FaTrash } from 'react-icons/fa';
import InfoToValidate from './InfoToValidate';
import InfoCotisation from './InfoCotisation';
import { cleanJson } from './utils/Columns';
import CotisationSel from './CotisationSel';
import TarifManuel from './TarifManuel';
import Stepper from 'react-stepper-horizontal';
import InfoAdherent from './InfoAdherent';
import InfoCotisationSel from './InfoCotisationSel';
import InfoTypePaiement from './InfoTypePaiement';
import InfoPaiement from './InfoPaiement';
import GenerePdf from './GenerePdf';
import IbanForm from './IbanForm';

const AdhesionByUser = ({ gotoAuth, adherentId, unSelAdherent, handleModifAdherent }) => {

    const url = localStorage.getItem('url');
    const smallurl = localStorage.getItem('smallurl');
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    const [showMaj, setShowMaj] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés
    const code = localStorage.getItem('code');

    useEffect(() => {
        if (url && url !== '') {
            getData();
        }
    }, []);

    const getData = () => {
        console.log('code', code);
        if (code === '') {
            gotoAuth();
            return;
        }
        // Appel de l'API
        return fetch(`${url}GetInfoAdherent/${adherentId}/${code}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.data)
                    gotoAuth();
                else {
                    let donnees = cleanJson(data.data);
                    let adh = donnees[0];
                    console.log('adh', adh);
                    setAdherentSel(adh);
                    handleModifAdherent();
                }

            })
            .catch(error => console.error('Erreur:', error));
    }

    const [showCotis, setShowCotis] = useState(false);
    const cotisationSel = {};

    const [showIban, setShowIban] = useState(false);
    const [showTarif, setShowTarif] = useState(false);
    const [showCotisSel, setShowCotisSel] = useState(false);

    const handleDelCotisation = () => {
        console.log('handleDelCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr de supprimer la cotisation de ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/0/0`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleChoixCotisation = (e) => {
        console.log('handleChoixCotisation', e)
        let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
        // console.log('handleChoixCotisation', e, reference);
        console.log('handleChoixCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/${e.cotisation_id}/${e.choix_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleTribuChange = (hasTribu) => {

        console.log('handleTribuChange', hasTribu)
        setAdherentSel({ ...adherentSel, tribu: hasTribu ? 1 : 0 })
        fetch(`${url}AffecteTribu/${adherentSel.adherent_id}/${hasTribu ? 1 : 0}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.status)
                    alert("rien à envoyer")
                else {
                    console.log(data.data);
                    getData();
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const handleSivChange = (hasSiv) => {

        console.log('handleSivChange', hasSiv)
        setAdherentSel({ ...adherentSel, siv: hasSiv ? 1 : 0 })
        fetch(`${url}AffecteSiv/${adherentSel.adherent_id}/${hasSiv ? 1 : 0}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.status)
                    alert("rien à envoyer")
                else {
                    console.log(data.data);
                    getData();
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const handleTarifSelected = (type, nb) => {
        console.log('handleTarifSelected', type, nb)
        console.log('handleTarifSelected', adherentSel);
        if (window.confirm(`Êtes vous sûr de sélectionner ${type} en ${nb} fois ?`)) {

            fetch(`${url}AffecteTarif/${adherentSel.adherent_id}/${nb}/${type}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);

                        getData().then(() => {
                            if (type === 'PRELEVEMENT')
                                setShowIban(true);
                        });
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleValidePaid = (paid_id, date) => {
        console.log('handleValidePaid', paid_id)
        console.log('handleValidePaid', adherentSel);
        if (window.confirm(`Êtes vous sûr de valider le paiement ?`)) {

            fetch(`${url}AffectePaid/${adherentSel.adherent_id}/${paid_id}/${date}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const sendFacture = (type) => {
        console.log('sendFacture', adherentSel)

        let possibilite = [{ libelle: 'au client', type: 'client' }
            , { libelle: 'à la comptabilité', type: 'comptable' }
            , { libelle: 'à la comptabilité et au client', type: 'both' }
        ]

        let possible = possibilite.find(el => el.type === type);

        if (window.confirm(`Êtes vous sûr d'envoyer la facture ${possible.libelle} ?`)) {

            fetch(`${url}SendFacture/${type}/${adherentSel.paiement_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        alert(`Facture ${data.facture} envoyée ${possible.libelle}`);
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }


    const handleFeuilleClick = (row) => {
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        setAdherentSel(row);
        setShowCotisSel(true);
    };

    const etats = [
        { title: 'Sélection de la feuille de cotisation', etat: 'nocotisationid' },
        { title: 'Tribu', etat: 'notribu' },
        { title: 'Moyen de paiement', etat: 'nopaiement' },
        { title: 'Valider les paiements reçu', etat: 'nopaid' },
        { title: 'Facture', etat: 'ok' }]

    const steps = etats.map((el, index) => {
        // console.log(el.etat, currentEtat)
        return {
            title: el.title,
            // onClick: (e) => {
            //     console.log('onClick', el.etat);
            //     e.preventDefault();
            //     setCurrentEtat(el);
            //     filtreData(allData, el);
            // }
        }
    });


    const currentStep = etats.length;

    const handleModifiable = (e) => {
        handleFeuilleClick(adherentSel)
    }

    const getCotisation = () => {
        console.log("getCotisation", adherentSel)
        let myChoix = cotisations.find(el => el.id === adherentSel.cotisation_id2);
        if (myChoix) {
            console.log("mychoix", myChoix)
            return <InfoCotisationSel cotisation={myChoix} choix_id={adherentSel.choix_id} paiement_en_x_fois={adherentSel.nb_fois} handleModifiable={handleModifiable} />
        }
    }


    return (
        <div>
            {/* <Button variant="secondary" onClick={() => setShowNew(true)}>
                Nouvel adhérent
            </Button>
            a envoyer : <FaPaperPlane />
            envoyé : <FaEnvelope />
            connecté sur le site :<FaEnvelopeOpen />
            mergé : <FaEnvelopeOpenText /> */}
            {/* <h1>{adherentSel.etat}</h1> */}
            {JSON.stringify(adherentSel) !== '{}' && (<>
                <h1>Adhérent&nbsp;<Button variant="primary" onClick={unSelAdherent}>Déselectionner</Button></h1><br />
                <Stepper steps={steps} activeStep={currentStep} /><br />
                <div className="row">
                    <div className="col-6">
                        <InfoAdherent adherent={adherentSel} />
                    </div>
                    <div className="col-6">
                        {adherentSel.reference !== '' && adherentSel.choix_id !== '' && adherentSel.choix_id !== 0 && (<>
                            {getCotisation()}
                        </>)}
                        {!(adherentSel.reference !== '' && adherentSel.choix_id !== '' && adherentSel.choix_id !== 0) && <>
                            <div className="d-grid gap-2">
                                <Button variant="primary" onClick={() => handleFeuilleClick(adherentSel)}>Selectionner une feuille de cotisation</Button>
                            </div>
                        </>}
                        <br></br>
                    </div>
                    {adherentSel.reference !== '' && adherentSel.choix_id !== '' && adherentSel.choix_id !== 0 && (<>
                        <div className="col-6">
                            <InputGroup className="mb-3" width='100%'>
                                <InputGroup.Text>Accès à la cession de créance « TRIBU » au prix de {adherentSel.tribu_montant} €</InputGroup.Text>
                                <ToggleButton
                                    id={"toggle-check-oui"}
                                    type="checkbox"
                                    variant={adherentSel.tribu === 1 ? 'success' : 'outline-success'}  // 'light' pour la variante "Non"
                                    checked={adherentSel.tribu === 1}
                                    onChange={(e) => handleTribuChange(true)}
                                >
                                    Oui
                                </ToggleButton>

                                <ToggleButton
                                    id={"toggle-check-non"}
                                    type="checkbox"
                                    variant={adherentSel.tribu === 0 ? 'danger' : 'outline-danger'}  // 'light' pour la variante "Oui"
                                    checked={adherentSel.tribu === 0}
                                    onChange={(e) => handleTribuChange(false)}
                                >
                                    Non
                                </ToggleButton>
                            </InputGroup>
                            <InputGroup className="mb-3" width='100%'>
                                <InputGroup.Text>Accès au SIV au prix de {adherentSel.siv_montant} €</InputGroup.Text>
                                <ToggleButton
                                    id={"toggle-check-oui-siv"}
                                    type="checkbox"
                                    variant={adherentSel.siv === 1 ? 'success' : 'outline-success'}  // 'light' pour la variante "Non"
                                    checked={adherentSel.siv === 1}
                                    onChange={(e) => handleSivChange(true)}
                                >
                                    Oui
                                </ToggleButton>

                                <ToggleButton
                                    id={"toggle-check-non-siv"}
                                    type="checkbox"
                                    variant={adherentSel.siv === 0 ? 'danger' : 'outline-danger'}  // 'light' pour la variante "Oui"
                                    checked={adherentSel.siv === 0}
                                    onChange={(e) => handleSivChange(false)}
                                >
                                    Non
                                </ToggleButton>
                            </InputGroup>
                            {[0, 1].includes(adherentSel.tribu) && [0, 1].includes(adherentSel.siv) && (<>
                                <InfoTypePaiement adherent={adherentSel} nb_fois_max={adherentSel.six_fois === 1 ? 6 : (adherentSel.trois_fois === 1 ? 3 : 1)} handleTarifSelected={handleTarifSelected} />
                            </>)}

                        </div>
                        <div className="col-6">
                            <InputGroup className="mb-3" width='100%'>
                                <InputGroup.Text>Accès au service « SIV » au prix de {adherentSel.siv_montant} €</InputGroup.Text>
                                <ToggleButton
                                    id={"toggle-check-oui-siv"}
                                    type="checkbox"
                                    variant={adherentSel.siv === 1 ? 'success' : 'outline-success'}
                                    checked={adherentSel.siv === 1}
                                    onChange={(e) => handleSivChange(true)}
                                >
                                    Oui
                                </ToggleButton>

                                <ToggleButton
                                    id={"toggle-check-non-siv"}
                                    type="checkbox"
                                    variant={adherentSel.siv === 0 ? 'danger' : 'outline-danger'}
                                    checked={adherentSel.siv === 0}
                                    onChange={(e) => handleSivChange(false)}
                                >
                                    Non
                                </ToggleButton>
                            </InputGroup>

                        </div>
                        {adherentSel.type && (adherentSel.type !== 'PRELEVEMENT' || adherentSel.iban === 1) && (<div className="col-6">
                            <InfoPaiement adherent={adherentSel} handleValidePaid={handleValidePaid} />
                        </div>
                        )}
                    </>)}

                </div>
                {adherentSel.montant_num_1 > 0 && (adherentSel.type !== 'PRELEVEMENT' || adherentSel.iban === 1) && <>
                    <hr />
                    <div className='text-center'>
                        {adherentSel.paid === 1 && (<p className='text-success'><h1>Paiement validé</h1></p>)}
                        {adherentSel.paid === 0 && (<p className='text-danger'><h1 variant="success">Paiement non validé</h1></p>)}
                        Voir la facture : <GenerePdf fichier='facture' data={adherentSel} visible={true} /><br /><br />
                        <div className="d-grid gap-2">
                            <Button variant='primary' onClick={() => sendFacture('client')}>Envoi de la facture au client ({adherentSel.mail}) <FaEnvelope /></Button>

                            <Button variant='primary' onClick={() => sendFacture('comptable')}>Envoi de la facture à la comptabilité <FaEnvelope /></Button>

                            <Button variant='primary' onClick={() => sendFacture('both')}>Envoi de la facture à la comptabilité <b>et</b> au client ({adherentSel.mail}) <FaEnvelope /></Button>
                        </div>
                    </div>
                </>}
            </>)}

            <Modal size="xl" show={showCotis} onHide={() => setShowCotis(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoCotisation cotisation={cotisationSel} choix_id={adherentSel.choix_id} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showCotisSel} onHide={() => setShowCotisSel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Sélection d'une cotisation pour <b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button variant='outline-danger' onClick={handleDelCotisation}><FaTrash /></Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationSel gotoAuth={gotoAuth} handleChoixCotisation={handleChoixCotisation} closemodal={() => setShowCotisSel(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showMaj} onHide={() => setShowMaj(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoToValidate adherentLight={adherentSel} gotoAuth={gotoAuth} reloadData={getData} closemodal={() => setShowMaj(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showTarif} onHide={() => setShowTarif(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Selection du tarif</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TarifManuel adherentSel={adherentSel} reloadData={getData} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showIban} onHide={() => setShowIban(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>IBAN</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <IbanForm nb_fois={adherentSel.nb_fois}
                        paiement_id={adherentSel.paiement_id}
                        adherent_id={adherentSel.adherent_id}
                        code={adherentSel.code}
                        handleSuccessPaiement={() => { setShowIban(false); getData() }}
                        ibanExist={adherentSel.iban === 1} />
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default AdhesionByUser;
